<div
  id="term-condition-page"
  data-spy="scroll"
  data-target=".navbar"
  data-offset="60"
>
  <div class="text-center">
    <h1>Term and Condition</h1>
  </div>
  <div class="settings-tab-data">
    <div>
      <div class="text-center my-3">
        <img
          src="https://wooffertechnologies.com/assets/img/legal-terms.png"
          class="img-fluid"
        />
      </div>
      <p>
        Wooffer's Working Together Priorities aim to enhance the quality and
        security of independent work in the United States. With industry change,
        along with government action, we believe our Priorities will improve
        work for millions of independent workers, while preserving the
        flexibility that we know you value.
      </p>

      <h3>Important Questions</h3>

      <h4>My toll or parking fee wasn't included in my fare</h4>
      <p>
        When your vehicle passes through a toll on a trip, Wooffer uses
        geographic technology to add the toll amount to your rider's fare
        automatically. The Wooffer fee is not applied to any toll-related
        charges added to the fare, and these rebates can be found on your
        earnings statement. If a toll-related rebate is not appearing on your
        earnings statement, please provide details and we will review. Please
        note that in US and Canadian cities, you won't receive a rebate for
        general parking fees incurred while on a trip.
      </p>

      <h4>I was in an accident</h4>
      <p>
        If you are involved in an accident, contact the police and paramedics if
        necessary. You can let us know what happened by checking that you have
        selected the correct trip and sharing all available info here. A member
        of our team will reach out. Please provide clear, bright photos of all
        four sides of your vehicle. Even if the accident did not result in
        visible damage or only damaged a specific area, we request photos of
        your entire vehicle.
      </p>
      <p>
        Accidents expenses are not covered by Wooffer technologies, Inc. You
        need to contact your insurance for accidental coverage.
      </p>

      <h4>My rider was rude</h4>
      <p>
        Our rating system is in place to help keep Wooffer comfortable and safe
        for everyone. However, we understand that you may have some trip
        experiences with riders where you may want to provide additional
        feedback. One way of providing feedback is through ratings. When rating
        your trips, please enter a rating that reflects your trip experience
        with the rider. Please note, we do not change rider ratings once they
        have been entered into the app.
      </p>

      <h4>The rider or pet made a mess in my vehicle</h4>
      <p>
        We've updated our Cleaning Fee Policy. Please go through the details on
        this page carefully to submit a cleaning fee claim. Please email your
        complaint and all the supporting documents and photos to
        info@wooffertechnologies.com. If a rider made a mess in your vehicle
        that requires significant cleaning/repair, please let us know here. We
        may be able to charge the rider and issue you a cleaning fee. This
        process may take up to 60 days to be completed.
      </p>
      <h4>To request a cleaning fee</h4>
      <p>
        Please submit a photo of the mess along with the receipt for the
        cleaning service within 3 business days of the trip. A receipt must have
        the following details in order to be valid:
      </p>
      <ul>
        <li>
          The date of service (must be within 3 days of the trip where the mess
          was made)
        </li>
        <li>The name of the cleaning service</li>
      </ul>
      <p>
        Please note that for minimum messes are not covered with this policy.
        For example, for incidents that require cleaning between the window/door
        or air vents, or for items that can be thrown away or wiped up quickly.
      </p>
      <p>
        Cleaning Fee Guide Fee assessments vary by type of mess and severity.
        Based on the photos and receipt provided, you may be eligible to receive
        payments up to the following amounts:
      </p>
      <ul>
        <li>
          $20-$30: Small interior mess that requires vacuuming or simple
          cleaning (e.g., minor food/beverage spills, minor bodily fluid mess,
          dirt, etc.); Moderate exterior mess (e.g., food/beverage mess on
          vehicle exterior)
        </li>
        <li>
          $40-$50: Moderate interior mess (e.g., larger food/beverage spill on
          fabric or other hard-to-clean surfaces/areas, moderate bodily fluid
          messes)
        </li>
        <li>$100: Major interior bodily fluid mess</li>
      </ul>

      <h4>I found an item</h4>
      <p>
        Let us know if you notice an item left in your vehicle. We'll try to
        connect you with the rider so you can arrange a mutually convenient time
        and place to return the item. Riders can call you through the app
        without seeing your personal phone number. If you'd prefer to get a text
        message, we can send them your personal number, but they'll have this
        number indefinitely and/or as long as they choose to retain it.
      </p>

      <h4>Critical Safety Response Line</h4>
      <p>
        If you require immediate police or medical attention, please call 911.
        Once all parties are out of harm's way and the necessary authorities
        have been contacted, please click on the link below to speak with a
        Wooffer representative.
      </p>

      <p>
        Hold Harmless agreement laws and agreement will be applied to any
        services released from Wooffer Technologies. The driver agrees to hold
        Wooffer Technologies harmless from any future issues raised by the rider
        or riders’ pet. Wooffer Technologies is committed to providing the
        highest client-focused service based on high integrity and
        sustainability, however, Wooffer will not be responsible for any
        incidents caused by the clients or their pets during or after the rides
        and usage of services.
      </p>

      <h4>Trips recommendations</h4>
      <ul>
        <li>
          Go offline when you are not available to undertake trips. Wooffer
          reserves the right to enforce a breach of your contractual agreements
          or restrict access to the platform if you are found to be in breach of
          the cancellation policy.
        </li>
        <li>
          Without limitation, Wooffer considers the following cancellation
          behaviors to be in breach of the Services Agreement:
        </li>
        <li>
          Refusing to complete a trip for a rider based on their intended
          destination.
        </li>
        <li>
          Refusing to complete a trip for your rider based on the fare multiple
          applied by Wooffer's Dynamic Pricing.
        </li>
        <li>
          Refusing to complete a trip for your rider for any reason that would
          be in breach of relevant discrimination laws and the conditions set
          out in your Private Hire Driver license.
        </li>
      </ul>

      <h4>Privacy Notice Policy and Information</h4>
      <p>
        Wooffer's Privacy Notice describes the information we collect, how it is
        used and shared, and your choices regarding this information. This
        policy applies to any users of the services of Wooffer or its affiliates
        anywhere in the world, and to anyone else who contacts Wooffer or
        otherwise submits information to Wooffer, unless noted in the Privacy
        Notice.
      </p>

      <h4>Wooffer Technologies Privacy Notice</h4>
      <p>
        Introduction: When you use Wooffer Technologies, you trust us with your
        personal data. We’re committed to keeping that trust. That starts with
        helping you understand our privacy practices. This notice describes the
        personal data we collect, how it’s used and shared, and your choices
        regarding this data. We recommend that you read this along with our
        privacy overview, which highlights key points about our privacy
        practices.
      </p>
      <p><strong>Last modified: April 1, 2021</strong></p>
      <p><strong>Effective date: April 1, 2021</strong></p>
      <p>
        Read full policy
        <a
          href="https://drive.google.com/file/d/1uXMZLA5LU61bn6DS9XpDKyx5sIxplmSk/view?usp=sharing"
          target="_blank"
          >here</a
        >
      </p>

      <h4>Overview: Scope</h4>
      <p>
        This notice applies to users of Wooffer Technologies’s services anywhere
        in the world, including users of Wooffer Technologies’s apps, websites,
        features, or other services.
      </p>
      <p>
        This notice describes how Wooffer Technologies and its affiliates,
        including Postmates, collect and use personal data. This notice applies
        to all users of our apps, websites, features, or other services anywhere
        in the world, unless covered by a separate privacy notice, such as the
        Wooffer Technologies Freight Privacy Notice or Careem Privacy Policy.
      </p>
      <p>This notice specifically applies to:</p>
      <ul>
        <li>
          Riders: individuals who request or receive transportation, including
          those who receive transportation requested by another individual.
        </li>
        <li>
          Drivers: individuals who provide transportation to Riders individually
          or through partner transportation companies.
        </li>
        <li>
          Delivery recipients: individuals who request or receive food, or other
          products and services, including via Wooffer Technologies Eats or
          Postmates.
        </li>
        <li>
          Delivery persons: individuals who provide delivery or other services,
          Wooffer Technologies Eats or Postmates.
        </li>
      </ul>

      <h4>Data collections and uses</h4>
      <p>Wooffer Technologies collects:</p>
      <ul>
        <li>
          Data provided by users to Wooffer Technologies, such as during account
          creation
        </li>
        <li>
          Data created during use of our services, such as location, app usage,
          and device data
        </li>
        <li>
          Data from other sources, such as Wooffer Technologies partners and
          third parties that use
        </li>
        <li>Wooffer Technologies APIs</li>
      </ul>
      <p><br /><strong>Choice and transparency&nbsp;</strong></p>
      <p>
        Wooffer Technologies enables users to access and control the data that
        Wooffer Technologies collects, including through:
      </p>
      <ul>
        <li>In-app settings</li>
        <li>Device permissions</li>
        <li>In-app ratings pages</li>
        <li>Marketing opt-outs</li>
      </ul>
      <p>
        Wooffer Technologies also enables users to request access to or copies
        of their data, changes or updates to their accounts, deletion of their
        accounts, or that Wooffer Technologies restrict its processing of user
        personal data.
      </p>
      <p><br /><strong>Updates&nbsp;</strong><strong>to this notice</strong></p>
      <p>
        We may occasionally update this notice. Use of our services after an
        update constitutes consent to the updated notice to the extent permitted
        by law.
      </p>
      <p>
        We may occasionally update this notice. If we make significant changes,
        we will notify users in advance of the changes through the Wooffer
        Technologies apps or through other means, such as email. We encourage
        users to periodically review this notice for the latest information on
        our privacy practices.
      </p>
      <p>
        After such notice, use of our services by users in countries outside the
        European Union will be understood as consent to the updates to the
        extent permitted by law.
      </p>
      <p><br /></p>
      <p>
        <strong>Pet Policy<br /></strong><span><br /></span>
      </p>
      <p>
        <span
          >1. By accepting and ordering Wooffer rider for your pet, you , user,
          declare&nbsp;</span
        ><strong><br /></strong>
      </p>

      <ul>
        <li>Your pet will not be feed it by the driver.</li>
        <li>
          Your pet will not be taken to outside for the walk or potty during the
          ride session.
        </li>
        <li>
          Your pet is up to date with all the vaccines and preventative cares
          according to UnitedStates and European counties laws.
        </li>
        <li>Your pet is not an aggressive pet.</li>
        <li>You pet is equipped with a reliable neck collar and the leash.</li>
        <li>
          You Pet may enjoy its own toys. Toys must be removed from vehicle once
          delivery has been completed.
        </li>
      </ul>

      <p>2. “Dangerous dog breeds”&nbsp;</p>
      <p>
        Wooffer will not register or approve account users own any breed of dog
        listed under the Dangerous Dogs Act 1991 (amended 1997) or where there
        is a pet which comes under the Dangerous Wild Animals Act 1976.<br /><br />
      </p>

      <p>3. Hold harmless Agreement&nbsp;</p>
      <p>
        Hold Harmless agreement laws and agreement will be applied to any
        services released form Wooffer Technologies. Wooffer technologies is and
        will always be committed to provide highest client focused service which
        is based on high integrity and sustainability of its services; however,
        wooffer will not be responsible or reliable including but not limited to
        the clients acts during or after the rides and usage of our services.
      </p>
      <p><br />4. Pet attacks&nbsp;</p>

      <p>
        Wooffer’s driver cabin is equipped with a live view Camera. For any
        attack originated by your pet to our driver, the pet owner will be fully
        responsible for any injury caused and the incident.
      </p>

      <!-- error -->
      <div style="display: none">
        <div class="text-center my-3">
          <img src="assets/img/legal-refund.png" class="img-responsive" />
        </div>
        <p class="ng-star-inserted">
          There may be some circumstances where a rider is charged and you would
          like to refund them because of an issue on your end.
        </p>
        <p>
          To refund the rider's fare or cancellation fee, send an email to
          info@wooffertechnologies.com and explain the reason. This action must
          be approved by Wooffer Technologies.
        </p>
        <p>
          NOTE: Refunding a rider means your earnings from the particular rider
          will be on hold until further investigations and results.
        </p>
      </div>

      <div style="display: none">
        <div class="text-center my-3">
          <img src="assets/img/legal-cancellation.png" class="img-responsive" />
        </div>
        <p class="ng-star-inserted">
          If you are not available for the ride and you received a ride request,
          feel free to cancel it. To cancel a ride, tap the 'Cancel' button.
        </p>
      </div>
    </div>
  </div>
</div>
